import { Component } from '@angular/core';
import { ANGULAR_MODULES } from './Shared/shared-imports';
import { ActivatedRoute, Params, Router, RouterOutlet } from '@angular/router';
import { take } from 'rxjs';
import { GeneralService } from './services/general.service';
import { WordReplacementService } from './services/word-replacement.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [ANGULAR_MODULES, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  marketId;
  constructor(private generalService: GeneralService,
    private wordReplacementService: WordReplacementService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.router.events.subscribe(() => {
      let child = this.route.firstChild;
      while (child?.firstChild) {
        child = child.firstChild;
      }

      const marketId = child?.snapshot.params['marketId'];

      if (marketId) {
        this.generalService.getTermsUsedInMarket(marketId)
          .pipe(take(1))
          .subscribe(res => {
            this.wordReplacementService.setTermMap({
              booth: res.BoothTerm,
              vendor: res.VendorTerm,
              market: res.MarketTerm
            });
          });
      }
    });
  }
}
